import { WrappedFormUtils } from 'antd/lib/form/Form'
import { Callback } from 'Src/types/utilTypes'
import { trimText } from 'Helpers'

type TGetOnChangeOptions = {
	form: WrappedFormUtils
	fieldName: string
	onChange: Callback<string, void>
	changeValue: Callback
}
type TGetOnBlurOptions = {
	currentValue: string
} & TGetOnChangeOptions
export const getOnChangeValue = ({
	form,
	fieldName,
	onChange,
	changeValue,
}: TGetOnChangeOptions) => {
	if (form)
		return (trimValue: string) => {
			form.setFieldsValue({ [fieldName]: trimValue })
			form.validateFields([fieldName])
			onChange?.(trimValue)
		}
	if (onChange) return changeValue
	return undefined
}

export const onBlurTrim =
	({ form, fieldName, onChange, changeValue, currentValue }: TGetOnBlurOptions) =>
	() => {
		if (form) {
			const value = form.getFieldValue(fieldName)
			const trimValue = trimText(value)
			if (value !== trimValue) {
				form.setFieldsValue({ [fieldName]: trimValue })
				form.validateFields([fieldName])
				onChange?.(trimValue)
			}
		} else {
			const trimValue = trimText(currentValue)
			if (trimValue !== currentValue) changeValue(trimValue)
		}
	}

export const onFocusQuotes =
	({ form, fieldName, onChange, ref }) =>
	() => {
		if (form) {
			const value = form.getFieldValue(fieldName)
			const quoteValue = '""'
			if (value === '' || value === undefined || value === null) {
				form.setFieldsValue({ [fieldName]: quoteValue })
				form.validateFields([fieldName])
				onChange?.(quoteValue)
				setTimeout(() => ref.current?.input.setSelectionRange(1, 1))
			}
		}
	}
